import styled, {DefaultTheme, FlattenSimpleInterpolation, css} from 'styled-components'

export const StyledRoot = styled.div(
    ({animationStyles}: {animationStyles?: (theme: DefaultTheme) => FlattenSimpleInterpolation}) => css`
        width: 100%;
        height: 100%;
        ${({theme}) => animationStyles && animationStyles(theme)};
    `
)
